/** Textos de `/entrar` e família (SPEC-v2 2.2; SPEC 9.11). */
export const authCopy = {
  documentTitle: (page: string) => `${page} · Rota`,
  login: {
    title: 'Entrar na Rota',
    subtitle: 'Painel, Automações e Estúdio do Do Zero aos EUA.',
    page: 'Entrar',
  },
  demoNote:
    'Demonstração: o acesso protege só este navegador. Não use uma senha que você usa em outro lugar.',
  twoFactor: {
    page: 'Verificação em duas etapas',
    title: 'Verificação em duas etapas',
    text: 'Abra o app autenticador e digite o código da Rota.',
    useRecovery: 'Usar código de recuperação',
    useApp: 'Usar o código do app',
    recoveryLabel: 'Código de recuperação',
    recoveryHint: 'Formato xxxx-xxxx. Cada código vale uma vez.',
    verify: 'Verificar',
    expired: 'O código expirou. Entre de novo com a senha.',
    back: 'Voltar ao login',
  },
  setup: {
    page: 'Configurar a Rota',
    title: 'Configurar a Rota',
    text: 'Primeira abertura neste navegador. Crie o acesso do dono; depois você convida a equipe.',
    name: 'Seu nome',
    email: 'E-mail',
    password: 'Senha',
    passwordHint: 'Pelo menos 15 caracteres. Uma frase longa funciona melhor que símbolos.',
    remember: 'Manter conectado neste aparelho',
    submit: 'Criar acesso e entrar',
    submitting: 'Criando o acesso',
    strength: (n: number) => (n >= 15 ? 'Tamanho bom' : `Faltam ${15 - n} caracteres`),
  },
  invite: {
    page: 'Aceitar convite',
    title: 'Você foi convidado para a Rota',
    text: 'Crie a sua senha, com pelo menos 15 caracteres. Depois é só entrar com o seu e-mail e essa senha.',
    name: 'Como quer ser chamado',
    password: 'Nova senha',
    submit: 'Aceitar e entrar',
    invalid: 'Este convite não vale mais. Peça um novo ao dono.',
    missing: 'Link de convite incompleto. Abra o link exatamente como você recebeu.',
  },
  forgot: {
    page: 'Esqueci a senha',
    title: 'Esqueci a senha',
    text: 'Informe o seu e-mail. Se ele tiver acesso, enviaremos as instruções.',
    email: 'E-mail',
    submit: 'Enviar instruções',
    sent: 'Se este e-mail tiver acesso à Rota, as instruções chegam em alguns minutos.',
    demo: 'Na demonstração não há envio de e-mail: peça ao dono um novo link em Equipe › Pessoas.',
    live: 'Ainda não há envio de e-mail: peça a quem administra o servidor da Rota para trocar a sua senha.',
    back: 'Voltar ao login',
  },
  reset: {
    page: 'Nova senha',
    title: 'Criar uma nova senha',
    text: 'Depois de trocar, as outras sessões são encerradas.',
    password: 'Nova senha',
    submit: 'Salvar a nova senha',
    done: 'Senha alterada. Entre com a nova senha.',
    goLogin: 'Ir para o login',
  },
} as const;
